module.exports = __webpack_public_path__ + "media/domenj/img-nosotros-contacto-16bb29d4.png";